import { Box, Stack, Typography } from '@mui/material';
import BestRating from 'assets/icons/am-best-rating.svg';
import { SvgIconWrapper } from 'components/SvgIconWrapper';
import type { FC } from 'react';

type AMBestRatingProps = {
  placement?: 'end' | 'initial';
};

const AMBestRating: FC<AMBestRatingProps> = ({ placement = 'initial' }) => {
  return (
    <Stack flexDirection="row" alignItems="center" gap={2} alignSelf={placement}>
      <Typography variant="body2">
        <Box component="span" sx={{ color: (theme) => theme.palette.customColors.copper }}>
          A++
        </Box>{' '}
        A.M. Best Rating
      </Typography>
      <SvgIconWrapper src={BestRating} />
    </Stack>
  );
};

export default AMBestRating;
